import { Button } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { SendlaneIcon } from '@mm/icons';
import React, { useEffect } from 'react';
import { ButtonColor } from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { BaseIntegration } from '../../../BaseIntegration/BaseIntegration';
import { BaseIntegrationHeader } from '../../../BaseIntegration/BaseIntegrationHeader';
import { useFetchConnections } from '../../../use-fetch-connections';
import { SendlaneSettings } from './SendlaneSettings';

export const SendlaneIntegrations = () => {
  const { fetch } = useFetchConnections();

  const sectionProps = {
    landmineName: landmineNames.SENDLANE_UPGRADE,
    featureFlag: 'nativeIntegrations',
  };

  useEffect(() => {
    fetch(1, 200, 'sendlane');
  }, [fetch]);

  const header = (
    <Button
      css={{ container: 'integrations__header-add-button-secondary' }}
      onClick={e => {
        e?.stopPropagation();
        window.open('https://app.sendlane.com/api', '_blank');
      }}
      color={ButtonColor.secondaryBlue}
    >
      Add a Connection
    </Button>
  );

  return (
    <BaseIntegration
      titleComponent={
        <BaseIntegrationHeader
          title="Sendlane"
          upgradeButtonName="Add a Connection"
          subtitle="Automatically sync your Customers.ai contacts to Sendlane"
          icon={<SendlaneIcon />}
          headerRightComponent={header}
          css={{ icon: 'integrations__sendlane-header-icon' }}
          {...sectionProps}
        />
      }
      integrationType="sendlane"
    >
      <SendlaneSettings />
    </BaseIntegration>
  );
};
